import React, { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIsMount } from 'helpers'
import { media } from 'helpers'
import styled from 'styled-components'

import HideVisually from 'js/components/HideVisually/HideVisually'
import NestedNav from 'js/components/NestedNav/NestedNav'
import globalStateContext from 'js/lib/withGlobalState/globalStateContext'
import PageBreadcrumb from 'js/page/PageBreadcrumb'

import PageRows from './PageRows'

const Wrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
`

export const PageNavWrapper = styled.div`
    flex-grow: 1; // Fill out height of page
    display: flex;

    ${media.mobilePortrait`
        flex-direction: column;
    `};
`

export const PageRowsWrapper = styled.div`
    flex-grow: 1; // Fill out width of page
    display: flex;
    flex-direction: column;
    overflow: hidden; // Prevent content from overflowing on the right side (happens when Swiper slides exceed screen width)

    /* Prevent card shadows from being cut off */
    margin-top: -20px;
    padding-top: 20px;
    pointer-events: none; // Fix page overlaying previous divs

    > * {
        pointer-events: auto; // Reset pointer events for children
    }

    .PageRow:last-child {
        flex-grow: 1; // Fill out last row background color
    }
`

const Page = ({ site, entity, viewer }) => {
    const isMount = useIsMount()

    const {
        globalState: { editMode },
    } = useContext(globalStateContext)

    const navigate = useNavigate()
    const location = useLocation()

    const {
        guid,
        title,
        rows,
        group,
        canEdit,
        rootParent,
        showNavigation,
        parent,
    } = entity

    useEffect(() => {
        if (editMode && !isMount) {
            navigate(`/page/edit/${guid}`, {
                state: { prevPathname: location.pathname },
            })
        }
        // eslint-disable-next-line
    }, [editMode])

    const showPageNav = rootParent ? rootParent.showNavigation : showNavigation

    return (
        <Wrapper data-guid={guid}>
            <HideVisually as="h1">{title}</HideVisually>

            <PageBreadcrumb guid={guid} />

            <PageNavWrapper $hasBreadcrumbs={!!parent}>
                {showPageNav && (
                    <NestedNav
                        viewer={viewer}
                        editMode={editMode}
                        entityType="page"
                        guid={guid}
                    />
                )}
                <PageRowsWrapper>
                    <PageRows
                        site={site}
                        guid={guid}
                        rows={rows}
                        group={group}
                        canEdit={canEdit}
                    />
                </PageRowsWrapper>
            </PageNavWrapper>
        </Wrapper>
    )
}

export default Page
